var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-login-signup"},[_c('a',{staticClass:"c-top-nav__link c-cta c-cta--icon",attrs:{"href":"#"}},[_c('span',[_c('img',{attrs:{"src":"assets/glyphs/login-signup.svg","alt":""}}),_vm._v("Login")])]),_vm._v(" | "),_c('a',{staticClass:"c-top-nav__link c-cta c-cta--icon",attrs:{"href":"#"}},[_c('span',[_vm._v("Signup")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d4e388f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./demo/components/nav/login-signup.vue
// module id = 1148
// module chunks = 0